import { apiPaths } from '../config/apiPaths';
import { postJson } from '../postClient';

export const getWabaIdsApi = (inputData, authHeaders) =>
  postJson(apiPaths.whatsappChannel, inputData, authHeaders, {
    defaultError: 'Failed to fetch WABA IDs',
  });
